// @ts-ignore — formiojs v4 ships without first-class TS types
import { Components } from 'formiojs';
import { createRoot, type Root } from 'react-dom/client';
import VideoPlayer from './VideoPlayer';
import { videoPlayerSettings } from './VideoPlayer.settings';

const Field = Components.components.field;

export default class VideoPlayerComp extends Field {
    root: Root | null = null;

    static schema(...extend: any[]) {
        return Field.schema({
            type: 'videoplayer',
            label: 'Video Player',
            key: 'video',
            videoType: 'video/mp4',
            ...extend,
        });
    }

    static get builderInfo() {
        return {
            title: 'Video Player',
            group: 'custom',
            icon: 'video-camera',
            weight: 70,
            documentation: '/userguide/#videoplayer',
            schema: VideoPlayerComp.schema(),
        };
    }

    static editForm = () => {
        return videoPlayerSettings;
    }

    get defaultSchema() {
        return VideoPlayerComp.schema();
    }

    renderReact(element: HTMLElement) {
        if (!this.root) {
            this.root = createRoot(element);
        }

        this.root.render(
            <VideoPlayer
                component={this.component}
                value={this.dataValue}
            />
        );
    }

    attach(element: HTMLElement) {
        const ret = super.attach(element);

        // Remove any stale container + React root before re-mounting.
        // FormIO can call attach() again after a save without calling detach()
        // first, which would create a second React root on the same node.
        const old = element.querySelector('.videoplayer-react-container');
        if (old) {
            old.remove();
            if (this.root) {
                this.root.unmount();
                this.root = null;
            }
        }

        const container = document.createElement('div');
        container.className = 'videoplayer-react-container';
        element.appendChild(container);
        this.renderReact(container);
        return ret;
    }

    detach() {
        if (this.root) {
            this.root.unmount();
            this.root = null;
        }
        return super.detach();
    }
}
